module.exports = __webpack_public_path__ + "img/sierraint7.a8bdd35a.png";